export default __webpack_public_path__ + "static/media/2SHARES.5fb3f325.png";